import React, { useState, useEffect } from 'react';
import { MessageSquare, X, Minimize2, Maximize2 } from 'lucide-react';
import { Button } from './ui/button';
import AIChatInterface from './AIChatInterface';

const AIChatWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);
  const [hasUnreadMessages, setHasUnreadMessages] = useState(false);

  // Check for unread messages or notifications
  useEffect(() => {
    // This could be connected to a real-time notification system
    // For now, we'll simulate checking for pending items that might need AI assistance
    const checkForPendingItems = async () => {
      try {
        // This could check for pending approvals, new requests, etc.
        // For now, we'll just simulate it
        setHasUnreadMessages(false);
      } catch (error) {
        console.error('Failed to check for pending items:', error);
      }
    };

    checkForPendingItems();
    const interval = setInterval(checkForPendingItems, 30000); // Check every 30 seconds

    return () => clearInterval(interval);
  }, []);

  const toggleChat = () => {
    if (isMinimized) {
      setIsMinimized(false);
      setIsOpen(true);
    } else {
      setIsOpen(!isOpen);
    }
    setHasUnreadMessages(false);
  };

  const minimizeChat = () => {
    setIsMinimized(true);
    setIsOpen(false);
  };

  const closeChat = () => {
    setIsOpen(false);
    setIsMinimized(false);
  };

  // Floating button when chat is closed
  if (!isOpen && !isMinimized) {
    return (
      <div className="fixed bottom-6 right-6 z-50">
        <Button
          onClick={toggleChat}
          className="w-14 h-14 rounded-full bg-gradient-to-r from-yellow-400 to-yellow-600 hover:from-yellow-500 hover:to-yellow-700 text-black shadow-lg hover:shadow-xl transition-all duration-200 relative"
        >
          <MessageSquare className="w-6 h-6" />
          {hasUnreadMessages && (
            <div className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full border-2 border-white"></div>
          )}
        </Button>
      </div>
    );
  }

  // Minimized state
  if (isMinimized) {
    return (
      <div className="fixed bottom-6 right-6 z-50">
        <Button
          onClick={toggleChat}
          className="w-14 h-14 rounded-full bg-gradient-to-r from-yellow-400 to-yellow-600 hover:from-yellow-500 hover:to-yellow-700 text-black shadow-lg hover:shadow-xl transition-all duration-200 relative"
        >
          <MessageSquare className="w-6 h-6" />
          {hasUnreadMessages && (
            <div className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full border-2 border-white"></div>
          )}
        </Button>
      </div>
    );
  }

  // Open chat interface
  return (
    <div className="fixed bottom-6 right-6 z-50 w-96 h-[500px]">
      <AIChatInterface
        isMinimized={false}
        onToggleMinimize={minimizeChat}
        onClose={closeChat}
      />
    </div>
  );
};

export default AIChatWidget;